var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAnimalsSheep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0205 31.1236L22.3478 39.2368H20.4456L21.682 31.1122L25.0205 31.1236ZM8.12648 31.5231L11.056 39.2406H9.1537L5.65353 32.9631L8.12648 31.5231ZM28.9373 6.76699C28.9383 6.29845 29.1251 5.84945 29.4568 5.5185C29.7884 5.18755 30.2378 5.00168 30.7064 5.00168C30.7064 5.00168 37.4043 4.99788 37.4651 5.00168C38.247 5.04353 39.025 5.33458 39.6718 5.87673L45 10.349V11.1745C45 12.392 44.0108 13.3812 42.7934 13.3812H35.2357V14.0203L37.9863 15.2245C37.9863 15.2245 35.9034 19.8983 34.3778 23.7029C32.5383 28.2873 29.7419 29.3241 29.2416 29.4743L30.2308 39.2406H28.3285L25.6102 29.4953L8.46318 29.4439L3.08738 32.5636L1.90227 39.2406H0V30.7184L2.80774 27.9107V22.9381C2.30555 23.3433 1.74248 23.6743 1.13375 23.9197V18.133C1.13375 16.4362 1.7672 14.8878 2.80774 13.7084C3.49256 12.936 4.34858 12.3197 5.31873 11.9278C6.11613 11.6063 6.96805 11.4416 7.82782 11.4428H28.2258L32.5478 7.81513C31.2634 7.97997 29.9657 7.63436 28.9335 6.85259V6.76508H28.9392L28.9373 6.76699Z",
    fill: "#E4995A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAnimalsSheep);
export default __webpack_public_path__ + "static/media/ic-animals-sheep.e1c1b2617c750ed6d7baa58d8253e39f.svg";
export { ForwardRef as ReactComponent };